"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesList = exports.AiLogoStyles = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const AiImageStyles_style_1 = require("../AiImage/AiImageStyles.style");
const AiLogoStyles_style_1 = require("./AiLogoStyles.style");
function AiLogoStyles({ onStyleChange, selectedStyle, setStylesOpened, styles, title, }) {
    const handleStyleClick = (event, style) => {
        event.preventDefault();
        event.stopPropagation();
        onStyleChange(style.value);
        setStylesOpened(false);
    };
    return ((0, jsx_runtime_1.jsxs)(AiImageStyles_style_1.StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(AiImageStyles_style_1.StyledTitleWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', children: title }) }), (0, jsx_runtime_1.jsx)(StylesList, { onClick: handleStyleClick, selected: selectedStyle, styles: styles })] }));
}
exports.AiLogoStyles = AiLogoStyles;
function StylesList({ onClick, selected, styles, }) {
    return ((0, jsx_runtime_1.jsx)(AiImageStyles_style_1.StyledContent, { children: styles.map((style) => ((0, jsx_runtime_1.jsxs)(AiLogoStyles_style_1.StyleItem, { onClick: (event) => onClick(event, style), selected: style.value === selected, children: [(0, jsx_runtime_1.jsx)(AiImageStyles_style_1.StyleImageWrapper, { type: "size", style: style.imageUrl
                        ? { backgroundImage: `url(${style.imageUrl})` }
                        : {}, children: !style.imageUrl && (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "magic-wand", size: "Medium" }) }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Small', children: style.name })] }, `image-style-${style.value}`))) }));
}
exports.StylesList = StylesList;
//# sourceMappingURL=AiLogoStyles.js.map